// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * @shapeshiftoss/solana-api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 10.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CompressedNftCreator
 */
export interface CompressedNftCreator {
    /**
     * 
     * @type {string}
     * @memberof CompressedNftCreator
     */
    address: string;
    /**
     * 
     * @type {number}
     * @memberof CompressedNftCreator
     */
    share: number;
    /**
     * 
     * @type {boolean}
     * @memberof CompressedNftCreator
     */
    verified: boolean;
}

/**
 * Check if a given object implements the CompressedNftCreator interface.
 */
export function instanceOfCompressedNftCreator(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "address" in value;
    isInstance = isInstance && "share" in value;
    isInstance = isInstance && "verified" in value;

    return isInstance;
}

export function CompressedNftCreatorFromJSON(json: any): CompressedNftCreator {
    return CompressedNftCreatorFromJSONTyped(json, false);
}

export function CompressedNftCreatorFromJSONTyped(json: any, ignoreDiscriminator: boolean): CompressedNftCreator {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'address': json['address'],
        'share': json['share'],
        'verified': json['verified'],
    };
}

export function CompressedNftCreatorToJSON(value?: CompressedNftCreator | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'address': value.address,
        'share': value.share,
        'verified': value.verified,
    };
}

